import { ApiClient } from '@dozuki/web-js/utils';

const SITE_NOT_FOUND_ERR_CODE = 'site_not_found';

const SITE_DEACTIVATED_ERR_CODE = 'site_deactivated';

export function isInvalidSiteError(error: any): boolean {
   if (!ApiClient.isApiError(error)) {
      return false;
   }
   const code = error.response?.data?.code;
   return code === SITE_NOT_FOUND_ERR_CODE || code === SITE_DEACTIVATED_ERR_CODE;
}
